document.addEventListener("DOMContentLoaded", function() {
    function navigateBack() {
      window.history.back();
    }
  
    let backButton = document.querySelector('#navigate-back');

    if (!backButton) return;

    backButton.addEventListener('click', navigateBack);
  });